<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <h2>{{translate?.general.buttons.configure.singular}} {{data?.module == 'joType' ? translate?.setup.modules.types.label.plural : data?.module == 'assetType' ? translate?.asset.label.singular + ' ' +translate?.setup.modules.picklist.type.label.plural : translate?.setup.modules.types.sections.sec2.plural}}</h2>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__subheader">
        <h3>Reorder {{data?.module == 'joType' ? translate?.setup.modules.types.label.plural : data?.module == 'assetType' ? translate?.asset.label.singular + ' ' +translate?.setup.modules.picklist.type.label.plural : translate?.setup.modules.types.sections.sec2.plural }} {{translate?.setup.modules.types.messages.asTheyShouldAppearInThe}} {{ (data?.module == 'assetType' || data?.module == 'assetStatus') ? translate?.asset.label.singular : translate?.jobOrder.label.singular}} {{ (data?.module == 'joType'|| data?.module == 'assetType')  ? translate?.setup.modules.types.label.singular : translate?.setup.modules.picklist.jobOrder.status.label.singular}} {{translate?.setup.modules.types.messages.dropdown}}. {{translate?.general.buttons.toggleOff.singular}}
            {{translate?.setup.modules.types.messages.any}} {{translate?.general.status.inactive.singular}} {{ (data?.module == 'joType' || data?.module == 'assetType' )? translate?.setup.modules.types.label.plural : translate?.setup.modules.picklist.jobOrder.status.label.singular}}.</h3>
    </div>

    <div class="flx-modal__body p-0">
        <!-- inside your modal body or normal page -->
        <div class="jt-table">
            <!-- header -->
            <div class="jt-head">
                <div class="jt-head__label">{{translate?.setup.modules.types.fields.label.singular}}</div>
                <div class="jt-head__active">{{translate?.general.status.active.singular}}</div>
            </div>

            <!-- body -->
            <ng-container *ngIf="data?.module == 'joType'">
                <div class="jt-body" cdkDropList [cdkDropListData]="joTypeData"
                        (cdkDropListDropped)="onJOTypeReOrdered($event, 'joType')">
                    <!-- Active Rows -->
                    <div *ngFor="let joType of joTypeData; index as i" cdkDrag [cdkDragMatchSize]="true">
                        <div class="jt-row row-to-move">
                            <button class="jt-row__handle" type="button" aria-label="Reorder" cdkDragHandle>
                                <i class="fa-solid fa-grip-vertical"></i>
                            </button>

                            <div class="jt-row__label">
                                <span class="jt-label-pill">{{joType.label}}</span>
                            </div>
                            <div class="jt-row__active">
                                <p-inputSwitch [(ngModel)]="joType.active" (onChange)="onActiveToggle(joType, i, 'active', 'joType')"></p-inputSwitch>
                            </div>
                        </div>
                    </div>
                    <!-- Inactive rows -->
                    <div class="jt-row jt-row--inactive" *ngFor="let inactiveJO of inActiveJOTypes; index as idx;">
                        <button class="jt-row__handle" type="button" aria-label="Reorder">
                            <i class="fa-solid fa-grip-vertical"></i>
                        </button>

                        <div class="jt-row__label">
                            <span class="jt-label-pill">{{inactiveJO.label}}</span>
                        </div>
                        <div class="jt-row__active">
                            <p-inputSwitch [(ngModel)]="inactiveJO.active" (onChange)="onActiveToggle(inactiveJO, idx, 'inactive', 'joType')"></p-inputSwitch>
                        </div>
                    </div>

                    
                </div>
            </ng-container>
            <ng-container *ngIf="data?.module == 'joStatus'">
                <div class="jt-body" cdkDropList [cdkDropListData]="joStatusData"
                        (cdkDropListDropped)="onJOTypeReOrdered($event, 'joStatus')">
                    <!-- Active Rows -->
                    <div *ngFor="let status of joStatusData; index as si;" cdkDrag [cdkDragMatchSize]="true">
                        <div class="jt-row row-to-move">
                            <button class="jt-row__handle" type="button" aria-label="Reorder" cdkDragHandle>
                                <i class="fa-solid fa-grip-vertical"></i>
                            </button>

                            <div class="jt-row__label">
                                <span class="jt-label-pill">{{status.fieldLabel}}</span>
                            </div>
                            <div class="jt-row__active">
                                <p-inputSwitch [(ngModel)]="status.active" (onChange)="onActiveToggle(status, si, 'active', 'joStatus')"></p-inputSwitch>
                            </div>
                        </div>
                    </div>
                    <!-- Inactive rows -->
                    <div class="jt-row jt-row--inactive" *ngFor="let inactiveStatus of inActiveJOStatuses; index as inSi">
                        <button class="jt-row__handle" type="button" aria-label="Reorder">
                            <i class="fa-solid fa-grip-vertical"></i>
                        </button>

                        <div class="jt-row__label">
                            <span class="jt-label-pill">{{inactiveStatus.fieldLabel}}</span>
                        </div>
                        <div class="jt-row__active">
                            <p-inputSwitch [(ngModel)]="inactiveStatus.active" (onChange)="onActiveToggle(inactiveStatus, inSi, 'inactive', 'joStatus')"></p-inputSwitch>
                        </div>
                    </div>

                    
                </div>
            </ng-container>
            <ng-container *ngIf="data?.module == 'assetStatus'">
                <div class="jt-body" cdkDropList [cdkDropListData]="joStatusData"
                        (cdkDropListDropped)="onJOTypeReOrdered($event, 'assetStatus')">
                    <!-- Active Rows -->
                    <div *ngFor="let status of assetStatusData; index as si;" cdkDrag [cdkDragMatchSize]="true">
                        <div class="jt-row row-to-move">
                            <button class="jt-row__handle" type="button" aria-label="Reorder" cdkDragHandle>
                                <i class="fa-solid fa-grip-vertical"></i>
                            </button>

                            <div class="jt-row__label">
                                <span class="jt-label-pill">{{status.label}}</span>
                            </div>
                            <div class="jt-row__active">
                                <p-inputSwitch [(ngModel)]="status.active" (onChange)="onActiveToggle(status, si, 'active', 'assetStatus')"></p-inputSwitch>
                            </div>
                        </div>
                    </div>
                    <!-- Inactive rows -->
                    <div class="jt-row jt-row--inactive" *ngFor="let inactiveStatus of inActiveAssetStatuses; index as inSi">
                        <button class="jt-row__handle" type="button" aria-label="Reorder">
                            <i class="fa-solid fa-grip-vertical"></i>
                        </button>

                        <div class="jt-row__label">
                            <span class="jt-label-pill">{{inactiveStatus.label}}</span>
                        </div>
                        <div class="jt-row__active">
                            <p-inputSwitch [(ngModel)]="inactiveStatus.active" (onChange)="onActiveToggle(inactiveStatus, inSi, 'inactive', 'assetStatus')"></p-inputSwitch>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="data?.module == 'assetType'">
                <div class="jt-body" cdkDropList [cdkDropListData]="joTypeData"
                        (cdkDropListDropped)="onJOTypeReOrdered($event, 'assetType')">
                    <!-- Active Rows -->
                    <div *ngFor="let assetType of assetTypeData; index as i" cdkDrag [cdkDragMatchSize]="true">
                        <div class="jt-row row-to-move">
                            <button class="jt-row__handle" type="button" aria-label="Reorder" cdkDragHandle>
                                <i class="fa-solid fa-grip-vertical"></i>
                            </button>

                            <div class="jt-row__label">
                                <span class="jt-label-pill">{{assetType.label}}</span>
                            </div>
                            <div class="jt-row__active">
                                <p-inputSwitch [(ngModel)]="assetType.active" (onChange)="onActiveToggle(assetType, i, 'active', 'assetType')"></p-inputSwitch>
                            </div>
                        </div>
                    </div>
                    <!-- Inactive rows -->
                    <div class="jt-row jt-row--inactive" *ngFor="let inactiveAsset of inActiveAssetTypes; index as idx;">
                        <button class="jt-row__handle" type="button" aria-label="Reorder">
                            <i class="fa-solid fa-grip-vertical"></i>
                        </button>

                        <div class="jt-row__label">
                            <span class="jt-label-pill">{{inactiveAsset.label}}</span>
                        </div>
                        <div class="jt-row__active">
                            <p-inputSwitch [(ngModel)]="inactiveAsset.active" (onChange)="onActiveToggle(inactiveAsset, idx, 'inactive', 'assetType')"></p-inputSwitch>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

     <div class="flx-modal__footer">
        <button type="button"class="custella-btn-white" (click)="onCancelClick()">{{translate?.general.buttons.cancel.singular}}</button>
        <p-button type="button" [label]="translate?.general.buttons.save.singular" styleClass="h-32" (onClick)="submitOrder()"></p-button>
    </div>
</div>